import React from 'react';

const MODELS = [
  {
    id: 'llama-3-8b',
    name: 'Llama 3 (8B)',
    provider: 'Meta',
    description: 'State-of-the-art open source large language model for text generation and analysis.',
    tags: ['Text', 'Chat', 'Analysis'],
    status: 'Available'
  },
  {
    id: 'stable-diffusion-xl',
    name: 'Stable Diffusion XL',
    provider: 'Stability AI',
    description: 'High-fidelity image generation model capable of photorealistic outputs.',
    tags: ['Image', 'Generation', 'Art'],
    status: 'Available'
  },
  {
    id: 'whisper-v3',
    name: 'Whisper v3',
    provider: 'OpenAI',
    description: 'Robust speech recognition model for accurate transcription and translation.',
    tags: ['Audio', 'Transcription'],
    status: 'Available'
  },
  {
    id: 'mistral-7b',
    name: 'Mistral 7B',
    provider: 'Mistral AI',
    description: 'Efficient and powerful language model with strong reasoning capabilities.',
    tags: ['Text', 'Code', 'Reasoning'],
    status: 'Available'
  },
  {
    id: 'musicgen',
    name: 'MusicGen',
    provider: 'Meta',
    description: 'Generate high-quality music samples from text descriptions.',
    tags: ['Audio', 'Music', 'Generation'],
    status: 'Coming Soon'
  }
];

export default function AIModels() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">Open Source Models</h1>
        <p className="text-slate-400">Explore and utilize state-of-the-art open source AI models directly within the platform.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {MODELS.map((model) => (
          <div key={model.id} className="rounded-2xl border border-white/10 bg-white/5 p-6 hover:bg-white/10 transition group">
            <div className="flex justify-between items-start mb-4">
              <div className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 text-xs font-bold uppercase tracking-wide">
                {model.provider}
              </div>
              <span className={`text-xs font-medium ${model.status === 'Available' ? 'text-emerald-400' : 'text-amber-400'}`}>
                {model.status}
              </span>
            </div>
            
            <h3 className="text-xl font-bold mb-2 group-hover:text-blue-400 transition">{model.name}</h3>
            <p className="text-slate-400 text-sm mb-6 h-12 line-clamp-2">{model.description}</p>
            
            <div className="flex flex-wrap gap-2 mb-6">
              {model.tags.map(tag => (
                <span key={tag} className="px-2 py-1 rounded-md bg-black/30 border border-white/5 text-xs text-slate-300">
                  {tag}
                </span>
              ))}
            </div>

            <button 
              className={`w-full py-2 rounded-xl font-semibold transition ${
                model.status === 'Available' 
                  ? 'bg-white/10 hover:bg-white/20 text-white' 
                  : 'bg-white/5 text-white/40 cursor-not-allowed'
              }`}
              disabled={model.status !== 'Available'}
            >
              {model.status === 'Available' ? 'Use Model' : 'Coming Soon'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
